import { render } from "./artist_item.vue?vue&type=template&id=5b41f5cf&scoped=true"
import script from "./artist_item.vue?vue&type=script&lang=js"
export * from "./artist_item.vue?vue&type=script&lang=js"

import "./artist_item.vue?vue&type=style&index=0&id=5b41f5cf&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b41f5cf"]])

export default __exports__